export const getCurrencySymbol = (str) => { //返回货币
	if (null == str || str.length <= 0) return "¥";
	let symbol;
	str = str.toUpperCase(); //将小写字母准换为大写字母
	if (str === "EUR") symbol = "€";
	else if (str === "JPY") symbol = "￥";
	else if (str === "TWD") symbol = "NT$";
	else if (str === "KRW") symbol = "₩";
	else if (str === "RUB") symbol = "₽";
	else if (str === "CAD") symbol = "C$";
	else if (str === "GBP") symbol = "£";
	else if (str === "HKD") symbol = "HK$";
	else if (str === "BRL") symbol = "R$";
	else if (str === "AUD") symbol = "A$";
	else if (str === "MXN") symbol = "Mex$";
	else if (str === "PLN") symbol = "zł";
	else if (str === "CHF") symbol = "CHF";
	else if (str === "SEK") symbol = "kr";
	else if (str === "CZK") symbol = "Kč";
	else if (str === "NZD") symbol = "NZ$";
	else if (str === "COP") symbol = "COL$";
	else if (str === "SGD") symbol = "S$";
	else if (str === "MYR") symbol = "RM";
	else if (str === "ILS") symbol = "₪";
	else if (str === "PHP") symbol = "₱";
	else if (str === "DKK") symbol = "kr.";
	else if (str === "NOK") symbol = "kr";
	else if (str === "RON") symbol = "lei";
	else if (str === "INR") symbol = "₹";
	else if (str === "ARS") symbol = "$";
	else if (str === "BGN") symbol = "лв";
	else if (str === "TRY") symbol = "₺";
	else if (str === "ZAR") symbol = "R";
	else if (str === "ISK") symbol = "kr";
	else if (str === "KZT") symbol = "₸";
	else if (str === "HRK") symbol = "kn";
	else if (str === "RSD") symbol = "дин.";
	else if (str === "EGP") symbol = "E£";
	else if (str === "LBP") symbol = "ل.ل";
	else if (str === "VND") symbol = "₫";
	else if (str === "AED") symbol = "د.إ";
	else if (str === "SAR") symbol = "ر.س";
	else if (str === "NGN") symbol = "₦";
	else if (str === "CNY") symbol = "￥";
	else symbol = "$";
	return symbol;
};


export const getAttributeConversion = (str) => { //返回属性
	let attribute;
	switch (str) {
		case "1": //Sado
			attribute = "SADO";
			break;
		case "2": //Mado
			attribute = "MASO";
			break;
		case "3": //Dom
			attribute = "DOM";
			break;
		case "4": //Sub
			attribute = "SUB";
			break;
		case "5": //Sw
			attribute = "SWITCH";
			break;
	}
	return attribute;
};

export const getSexOrientations = (str) => { //返回性取向
	let attribute;
	switch (str) {
		case "1": //BIS
			attribute = "BIS";
			break;
		case "2": //HETERO
			attribute = "HETERO";
			break;
		case "3": //GAY
			attribute = "GAY";
			break;
		case "4": //LES
			attribute = "LES";
			break;
	}
	return attribute;
};